import { boxShadow, mediaHelper, paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { PageContainer } from './PageContainer';

export const PageHeaderContainer = styled.div`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
  border-bottom: 1px solid ${paletteHelper('borderPrimary')};
  padding-bottom: ${spacingHelper('medium')};
  ${boxShadow.headerBoxShadow}
`;

export const PageHeaderInnerContainer = styled(PageContainer)`
  padding-top: calc(${spacingHelper('threeExtraLarge')} * 2);
  ${mediaHelper('tabletMax')} {
    padding-left: ${spacingHelper('large')};
    padding-right: ${spacingHelper('large')};
  }
  ${mediaHelper('mobile')} {
    padding-top: calc(${spacingHelper('extraLarge')} * 2);
  }
`;
